import React from "react";
import axios from 'axios';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import { Link } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import TextField from '@material-ui/core/TextField';
import workStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/workStyle.jsx";

class SectionWork extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

      isSent: false,
      formControls: {
        sender_name: '',
        sender_phone: '',
        sender_mail: '',
        message: '',
        subject: "Landing form message",
        website: "Kinoscorp EN",
        zone: ''


      }
    };
    this.onChange = this.onChange.bind(this);
  }

  //const [signupModal, setSignupModal] = React.useState(false);
  onChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        this.setState({
          formControls: {
              ...this.state.formControls,
              [name]: value
            }
        });

      }

  onSubmit = (e) => {
        e.preventDefault();
        this.setState({isSent: true}) ;
        // get our form data out of state
        const { formControls } = this.state;

        axios.post('https://api.kinosgroup.com/api/v1/en/messages/contact', { formControls })
          .then((result) => {
            //access the results here....
          });
      }


  render() {
    const { classes } = this.props;
    const { formControls } = this.state;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem cs={12} sm={8} md={8}>
            <h2 className={classes.title}>How can we help you?</h2>

            <h4 className={classes.description}>
              DO YOU WANT TO BE AN AGENT ASSOCIATED WITH KINOS? BE PART OF A LARGE GROUP!
              Being a Partner Agent of the Kinos Group brand is synonymous with professionalism, innovation and quality.
            </h4>
            <h5 className={classes.description}>
              Please be aware that any personal data that you and others provide through this tool may be processed by Kinos. The protection of your personal data is very important to Kinos. Kinos will process your personal data in compliance with applicable data protection laws.
Your decision to provide your personal data to Kinos is voluntary. However, given that certain functionalities of this tool require personal data to function, functionalities will not work if you decide not to provide your personal data.
Kinos invites you to carefully read its <Link to="/privacy">privacy statement</Link>, which includes important information on why and how Kinos is processing your personal data.
            </h5>

            <form>
              <GridContainer>
                <GridItem xs={12} sm={6} md={6}>
                  <TextField
                      id="name"
                      label="Your name"
                      name="sender_name"
                      className={classes.formControl}
                      margin="normal"
                      fullWidth
                      value={formControls.sender_name}
                      onChange={this.onChange}

                    />
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <TextField
                      id="mail"
                      label="Your email"
                      name="sender_mail"
                      className={classes.formControl}
                      margin="normal"
                      fullWidth
                      value={formControls.sender_mail}
                      onChange={this.onChange}

                    />
                </GridItem>

                <TextField
                    id="message"
                    label="Your message"
                    name="message"
                    className={classes.textArea}
                    margin="normal"
                    fullWidth
                    multiline
                    rows={5}
                    value={formControls.message}
                    onChange={this.onChange}
                  />
                <GridItem
                  xs={12}
                  sm={4}
                  md={4}
                  className={`${classes.mrAuto} ${classes.mlAuto}`}
                >
                  { this.state.isSent ? (
                      <Button color="" onClick={this.onSubmit}>Message Sent</Button>
                        ) : (
                      <Button color="primary" onClick={this.onSubmit}>Send Message</Button>
                     )}

                </GridItem>
              </GridContainer>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(workStyle)(SectionWork);
